import React from 'react';
import { Box } from '@mui/material';
import DocumentListItem from './DocumentListItem';

function DocumentList({ documents, onEdit, onDownload }) {
  if (documents.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #ddd',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      {documents.map((doc, idx) => (
        <DocumentListItem
          key={doc.id}
          doc={doc}
          index={idx}
          totalDocs={documents.length}
          onEdit={onEdit}
          onDownload={onDownload}
        />
      ))}
    </Box>
  );
}

export default DocumentList;
